import React, { Component } from 'react'
import { connect } from 'react-redux'
import Lightbox from '../lightbox-container'
import {
  fetchCollectionRows
} from '../collection-container/actions'
import {
  getCollectionRequestId
} from '../collection-container/selectors'
import {
  navigateLevelUp
} from '../../lib/historyUtil'

class LightboxCollectionPage extends Component {

  componentDidMount() {
    this.requestRows()
  }
  
  componentDidUpdate(prevProps) {
    this.requestRows()
  }
  
  // Request rows only if rows are empty
  // And active is set to true
  // Active is if route matches 
  requestRows() {
    const { requestId, match, onRequestRows } = this.props 

    const active = (match && match.isExact)
    const id = active ? match.params.collectionId : null

    if (!id) return
    if (requestId === id) return
    if (!active) return

    onRequestRows && onRequestRows(id)
  }

  getLightboxHref(match, index) {
    const active = (match && match.isExact)
    const collectionId = active ? match.params.collectionId : null
    const artistId = active ? match.params.artistId : null

    let href = artistId ? `/artists/${artistId}` : ''
    return collectionId ? `${href}/collections/${collectionId}/${index}` : null
  }

  handleClickPrev = (maxIndex) => {    
    const { match, history } = this.props 

    const active = (match && match.isExact)
    const index = active ? match.params.index : null

    let prevIndex = parseInt(index, 10) - 1
    prevIndex = prevIndex < 1 ? maxIndex : prevIndex

    const href = this.getLightboxHref(match, prevIndex)

    if (href) {
      history && history.push(href)
    } else {
      console.error('No href could be created for lightbox prev.')
    }
  }

  handleClickNext = (maxIndex) => {
    const { match, history } = this.props 
    
    const active = (match && match.isExact)
    const index = active ? match.params.index : null

    let nextIndex = parseInt(index, 10) + 1
    nextIndex = nextIndex > maxIndex ? 1 : nextIndex

    const href = this.getLightboxHref(match, nextIndex)

    if (href) {
      history && history.push(href)
    } else {
      console.error('No href could be created for lightbox next.')
    }
  }

  handleClickBack = () => {
    const { match, history } = this.props 

    navigateLevelUp(match, history, 1)
  }

  handleUpdateSelected = (selectedIndex) => {
    const { match, history } = this.props 
    const active = (match && match.isExact)
    const index = active ? parseInt(match.params.index, 10) : null

    const newIndex = selectedIndex + 1

    if (newIndex !== index) {
      const href = this.getLightboxHref(match, newIndex)

      if (href) {
        history && history.push(href)
      } else {
        console.warn('No href could be created for lightbox update')
      }
    } 
  }

  shouldComponentUpdate(nextProps) {
    const { 
      match: nextMatch,
      pageExitComplete: nextPageExitComplete 
    } = nextProps
    const {
      match: prevMatch,
      pageExitComplete: prevPageExitComplete 
    } = this.props 

    if (nextMatch !== prevMatch) {
      const active = (nextMatch && nextMatch.isExact)
      const index = active ? nextMatch.params.index : null

      if (index === null) return false
      return true
    }

    if (nextPageExitComplete !== prevPageExitComplete) {
      return true
    }

    return false
  }
  
  render() {
    const { 
      onSetScroll, 
      onSaveScroll, 
      pageName, 
      pageExitComplete,
      match } = this.props 

    const active = (match && match.isExact)
    const id = active ? match.params.id : null
    const index = active ? match.params.index : null

    return (
      <div className="lightbox-collection-page">
        <Lightbox
          onSaveScroll={onSaveScroll}
          onSetScroll={onSetScroll}
          handleClickPrev={this.handleClickPrev}
          handleClickNext={this.handleClickNext}
          handleClickBack={this.handleClickBack}
          handleUpdateSelected={this.handleUpdateSelected}
          pageName={pageName}
          pageExitComplete={pageExitComplete}
          currentIndex={index}
          match={match}
          active={active}
          id={id} />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    requestId: getCollectionRequestId(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestRows: id => {
      dispatch(fetchCollectionRows(id))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LightboxCollectionPage)



// WEBPACK FOOTER //
// ./src/components/lightbox-collection-page/lightbox-collection-page.js